<template>
  <div class="chat-content">
    <!-- Text Message -->
    <template v-if="MsgMap['TEXT'] === type">
      <div
        class="chat-text"
        v-html="$options.filters.textToHtml(content)"
      ></div>
    </template>

    <!-- Image Message -->
    <template v-else-if="MsgMap['IMAGE'] === type">
      <el-image style="width: 16em; height: 16em;;" :src="content" :preview-src-list="[content]"></el-image>
    </template>

    <!-- Voice Message -->
    <template v-else-if="MsgMap['VOICE'] === type">
      <div class="audio-box flex"
        :style="[{justifyContent:isMe?'flex-end':'flex-start'}, {'width':(item.second*4)+'px'}]"
        @click="$emit('playVoice', {id:item.id,url:content})">
        <span class="length white m-r-10" v-if="isMe">{{item.second}}"</span>
        <ChatVoiceTrumpet :isPlay="voicePlay" :size="16" :direction="isMe ? 'left':'right'"
          :color="isMe ? 'white':'black'"></ChatVoiceTrumpet>
        <span class="length black m-l-10" v-if="!isMe">{{item.second}}"</span>
      </div>
    </template>

    <!-- Video Message -->
    <template v-else-if="MsgMap['VIDEO'] === type">
      <div class="video-box" @click="$emit('playVideo', {id:item.id,url:content})">
        <i class="play-icon el-icon-video-play"></i>
        <el-image style="width: 300px; height: 400px;" fit="cover" :src="videoPoster"></el-image>
      </div>
    </template>

    <!-- Goods Message -->
    <template v-else-if="MsgMap['GOODS'] === type">
      <div class="flex goods-message">
        <div class="goods-image m-r-10">
          <el-image
            :src="goods.image"
            style="width: 80px; height: 80px"
          ></el-image>
        </div>
        <div class="">
          <div class="goods-name nr line-2">
            {{ goods.name }}
          </div>
          <div class="goods-price m-t-10 xxl">￥{{ goods.price }}</div>
          <div class="goods-desc m-t-10 xs">仅限小程序查看</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ChatVoiceTrumpet from "@/components/ChatVoiceTrumpet";
import { E_Msg } from "@/utils/enum";
export default {
  name: "ChatContent",
  components: {
    ChatVoiceTrumpet,
  },
  props: {
    type: {
      type: [String, Number],
      require: true,
    },
    content: {
      type: [String, Number, Object],
      require: true,
    },
    imageURL: {
      type: String,
    },
    videoPoster: {
      type: String,
    },
    item: {
      type: Object,
    },
    voicePlay: {
      type: Boolean,
      default: false,
    },
    isMe: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      MsgMap: Object.freeze({ ...E_Msg })
    };
  },

  filters: {
    textToHtml(content) {

      return content.replace(
        /\[em-([a-z_]+)\]/g,
        `<span class="em em-$1"></span>`
      );
    },
  },

  computed: {
    goods() {
      return typeof this.content === 'string' ? JSON.parse(this.content) : this.content;
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-content {
  .goods-message {
    width: 300px;
    .goods-image {
      min-width: 80px;
      min-height: 80px;
    }

    .goods-price {
      color: #fb9400;
      font-weight: bold;
    }
  }
  .chat-text {
    word-wrap: break-word;
  }
  .audio-box {
		min-width: 50px;
		max-width: 270px;
    cursor: pointer;
	}
  .video-box {
    cursor: pointer;
    position: relative;
    .play-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 50px;
      color: #fff;
      z-index: 100;
    }
   }
}
</style>
